<div *ngIf="optionItem" class="item-head-box">
  <div class="subject-box" [innerHTML]="optionItem.title | resize | keepHtml"></div>
  <div class="sub-box" [innerHTML]="optionItem.msg | resize | keepHtml"></div>
  <div class="close-btn"
       *ngIf="closeBtn"
       (click)="onClose($event)">
  </div>
</div>

<div *ngIf="optionItem" class="item-body-box">
  <div class="toggle-btn-box">

    <a *ngFor="let option of optionItem.options"
       class="toggle-btn {{ optionItem.getter() === option.value ? 'on' : '' }}"
       (click)="SetOptionValue(optionItem, option.value)">
      <div class="{{ option.css ?? 'txt' }}"
           [innerHTML]="option.name | resize"></div>

    </a>

  </div>
</div>
